@charset "UTF-8";

/* src/app/modules/institutions/institutions-list/institutions-list.component.scss */
.cw-module {
  overflow: hidden;
}
/*# sourceMappingURL=institutions-list.component.css.map */
